<template>
    <v-list>
        <template v-for="channel in this.channels" >
        <v-list-item 
          v-if="channel.state == 'Up'" 
          two-line 
          :key='channel.id' 
          dense>
            <v-list-item-avatar>
            <v-icon v-if="channel.talking_status == 'on'">mdi-account-voice</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
            <v-list-item-title>{{channel.caller.name}}</v-list-item-title>
            <v-list-item-subtitle>{{channel.caller.number}}</v-list-item-subtitle>
            
            </v-list-item-content>
            <v-spacer></v-spacer>
            
            
            <v-btn icon v-if="channel.handRaised" v-on:click="lowerHand(channel)"><v-icon>mdi-hand-right</v-icon></v-btn>
            <v-btn icon v-if="!channel.muted" v-on:click="muteCaller(channel)"><v-icon>mdi-microphone</v-icon></v-btn>
            <v-btn icon v-if="channel.muted" v-on:click="unmuteCaller(channel)"><v-icon>mdi-microphone-off</v-icon></v-btn>

            <v-btn icon v-on:click="kickCaller(channel)" v-if="myChannel.admin"><v-icon>mdi-phone-hangup</v-icon></v-btn>
        </v-list-item>
        </template>
    </v-list>
</template>
<script>
import ConferenceCommon from '../mixins/conferencecommon.vue';
import Common from '../mixins/common.vue';
import ConferenceSettings from '../components/conference-settings.vue';
import Vue from 'vue';

export default Vue.extend({
  data: function() {
    return {

    }
  },

  mixins: [ConferenceCommon, Common,
    ConferenceSettings ],
  methods: {
    logState: function() {
      console.log(this.session);
    },
    logTab: function() {
      console.log(this.activeTab);
    },
    debug: function(e) {
        console.log('debug', e);
    },
    attachMedia() {
      // Return if there is no spot in page for media
      if (!this.$refs.media) return;
      // Return if there is no session
      if (!this.session) return;

      console.log('what is refs?', this.$refs);

      this.$refs.media.innerHTML = '';
      if (this.session.mediaElement) this.$refs.media[1].appendChild(this.session.mediaElement);

      this.$refs.localMedia.innerHTML='';
      if (this.session.localVideo) this.$refs.localMedia[1].appendChild(this.session.localVideo);
    },
    switchTab: function(num) {
      this.activeTab=num;
      console.log('switching tab to ', num)
    }
  },
  computed: {
    session: {
      get() { return this.$store.getters['sip/session'] },
    },
    state: {
      get: function() {
        if (this.session) {
          return this.session.state;
        }
        return null;
      }
    },
  },
  watch: {
    activeParticipants: function(newval, oldval) {
      if (newval) {
        this.switchTab(2)
        console.log('change to activeParticipants, switching tabs')
      }
    },
    session() {
      //this.attachMedia();
    },
  },
  async mounted() {
    
  }
  
})
</script>
